import { render, staticRenderFns } from "./association.vue?vue&type=template&id=5bece6c2&scoped=true"
import script from "./association.vue?vue&type=script&lang=js"
export * from "./association.vue?vue&type=script&lang=js"
import style0 from "./association.vue?vue&type=style&index=0&id=5bece6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bece6c2",
  null
  
)

export default component.exports